module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_footer_tvb-58d560dcfa2c8feb25fb838766be24cb.svg";